export const exportBlobFile = (filename: string, data: any) => {
  let blob = new Blob([data], { type: 'application/octet-stream' });
  if ('download' in document.createElement('a')) {
    let ele = document.createElement('a');
    ele.download = filename;
    ele.style.display = 'none';
    ele.href = URL.createObjectURL(blob);
    document.body.appendChild(ele);
    ele.click();
    document.body.removeChild(ele);
  } else {
    window.navigator.msSaveBlob(blob, filename);
  }
};

export const sleep = (time: number) => {
  return new Promise(resolve => setTimeout(resolve, time));
};

export const checkCode = (code: string = '') => {
  const reg = /^\w+$/;
  return reg.test(code);
};

export const checkEmpty = (str: string): boolean => {
  return str === '' || str === null || str === undefined;
};

export const checkCron = (cron: string = '') => {
  const reg = /^(((\d+,)+\d+|(\d+(\/|-)\d+)|\d+|\*|\?) ?){5,7}$/;
  return reg.test(cron);
};
export const StringFormat = (format: string, args: string[]) => {
  console.log('args', args);
  if (args.length < 1) {
    return '';
  }

  for (var key in args) {
    var value = args[key];
    if (undefined != value) {
      format = format.replaceAll('{' + key + '}', value);
    }
  }
  console.log('result', format);
  return format;
};

export const pagination = {
  defaultCurrent: 1,
  defaultPageSize: 10,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
  showTotal: (total: number) => `共${total}条记录`
};
